import { Box, ColumnLayout, ExpandableSection, SpaceBetween } from '@cloudscape-design/components';
import { FC } from 'react';
import { useLocalStorage } from 'react-use';
import { useAuthContext } from '../contexts/AuthContext';
import { useModuleTranslation } from '../lang';
import { Batch } from '../models/Batch';
import { costTotal } from '../utils/cost';

interface IIngredientsProps {
  batch: Batch;
  batchSize: number;
}

export const Ingredients: FC<IIngredientsProps> = ({ batch, batchSize }) => {
  const { currency } = useAuthContext();
  const [ingredientsExpanded, setIngredientsExpanded] = useLocalStorage<boolean>('ingredientsExpanded', false);
  const t = useModuleTranslation('Ingredients');

  return (
    <div style={{ marginTop: 10 }}>
      <ExpandableSection
        variant="container"
        headerText={t.header}
        expanded={ingredientsExpanded}
        onChange={({ detail }) => setIngredientsExpanded(detail.expanded)}
      >
        <ColumnLayout columns={2} variant="text-grid">
          {batch?.recipe?.ingredients.map((ingredient) => {
            const finalQuantity = batch.ingredientsConfirmed ? ingredient.quantity : ingredient.quantity * batchSize;

            return (
              <SpaceBetween key={ingredient.item.id + ingredient.quantity} size="m" direction="horizontal">
                <Box variant="awsui-key-label">{ingredient.item.name}</Box>
                <Box>
                  {finalQuantity.toFixed(2)} {ingredient.item.unit}{' '}
                  <small>
                    ({currency(ingredient.item.price?.toFixed(2) ?? '0.00')}{' '}
                    <strong>{currency(((ingredient.item.price ?? 0) * finalQuantity).toFixed(2) ?? '0.00')} </strong>)
                  </small>
                </Box>
              </SpaceBetween>
            );
          })}

          <SpaceBetween size="m" direction="horizontal">
            <Box variant="awsui-key-label">{t.total}</Box>
            <Box>
              <strong style={{ textDecoration: 'underline' }}>{batch && currency(costTotal(batch).toFixed(2))}</strong>
            </Box>
          </SpaceBetween>
        </ColumnLayout>
      </ExpandableSection>
    </div>
  );
};
